import React from 'react';
import { DownloadIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-cream pt-12 pb-16 px-4 md:pt-20 md:pb-24 overflow-hidden" data-id="element-37">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-38">
        {/* Text Content */}
        <div className="flex flex-col items-start z-10" data-id="element-39">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-gold/10 border border-rose-gold/20 mb-6" data-id="element-40">
            <StarIcon className="w-3 h-3 text-rose-gold fill-rose-gold" data-id="element-41" />
            <span className="text-xs font-bold tracking-widest text-rose-gold uppercase" data-id="element-42">
              MÉTODO EXCLUSIVO
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brown-primary leading-[1.1] mb-6" data-id="element-43">
            Piel de porcelana con menos de{' '}
            <span className="text-rose-gold italic" data-id="element-44">$500 pesos</span> en la
            farmacia de la esquina.
          </h1>

          <p className="text-lg md:text-xl text-brown-secondary mb-8 leading-relaxed max-w-xl" data-id="element-45">
            Logra una{' '}
            <span className="font-serif italic text-brown-primary" data-id="element-46">
              Piel de Vidrio
            </span>{' '}
            real usando joyas ocultas de tu farmacia local por menos de $350
            MXN.
          </p>
        </div>

        {/* Image Content + CTA below */}
        <div className="relative w-full flex flex-col items-center lg:items-end" data-id="element-47">
          <div className="relative w-full max-w-md lg:max-w-full aspect-[4/5] lg:aspect-square" data-id="element-48">
            <div className="absolute inset-0 bg-gold-soft/10 rounded-t-[10rem] rounded-b-lg transform rotate-3 scale-95 z-0" data-id="element-49"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7AVKnA4fwHJWrePDV3uG4e/mockup-3.png" alt="Piel de Vidrio Guía Digital en iPad" className="relative z-10 w-full h-full object-cover rounded-lg shadow-2xl" data-id="element-50" />
          </div>

          <div className="flex flex-col w-full sm:w-auto items-center mt-8" data-id="element-51">
            <a href="#precio" className="w-full sm:w-auto px-8 py-4 bg-rose-gold hover:bg-rose-dark text-white text-lg font-bold tracking-wide rounded-sm transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-center inline-block" data-id="element-52">
              ¡QUIERO MI GUÍA AHORA!
            </a>
            <div className="mt-3 flex items-center justify-center gap-2 text-sm text-brown-secondary/80" data-id="element-53">
              <DownloadIcon className="w-4 h-4" data-id="element-54" />
              <span data-id="element-55">Descarga inmediata · Acceso de por vida</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}